import React, { useEffect, useRef, useState } from 'react';

import { LayoutBottom, LayoutBottomHandler, LayoutBottomInner, LayoutContainer, Overlay } from './styles';

const SeparateLayout = (props) => {
    const [classBottom, setClassBottom] = useState('');
    const [openedBottomLayout, setOpenedBottomLayout] = useState(false);
    const [overlayShouldBeClosed, setOverlayShouldBeClosed] = useState(false);
    const [topPosition, setTopPosition] = useState(0);

    // animationInProgress: 0 - no animation, 1 - opening, -1 - closing
    const [animationInProgress, setAnimationInProgress] = useState(0);
    const ref = useRef(null);
    const refStartAnimation = useRef(false);
    const scrollStep = 0.5;

    useEffect(() => {
        const updatePosition = () => {
            const upContainer = document?.getElementById('top-container');
            const rect = upContainer?.getBoundingClientRect();
            const bottomLayoutPosition = rect?.bottom;
            setTopPosition(bottomLayoutPosition);
        };

        updatePosition();

        window.addEventListener('resize', updatePosition);

        return () => {
            window.removeEventListener('resize', updatePosition);
        };
    }, []);

    const openBottomLayout = () => {
        refStartAnimation.current = true;
        if (animationInProgress === 0) {
            setOpenedBottomLayout(true);
            setOverlayShouldBeClosed(true);
        }
        setAnimationInProgress(1);
        setClassBottom('bottom-move');
    };

    const closeBottomLayout = () => {
        refStartAnimation.current = true;
        setClassBottom('');
        setAnimationInProgress(-1);
        setOpenedBottomLayout(false);
        if (ref.current) {
            ref.current.scrollTop = 0;
        }
    };

    const resetScroll = () => {
        if (ref.current) {
            ref.current.scrollTop = scrollStep;
        }
    };

    const onScroll = () => {
        if (!refStartAnimation.current) {
            if (!openedBottomLayout) {
                openBottomLayout();
                return;
            }
            if (ref?.current?.scrollTop === 0) {
                if (overlayShouldBeClosed) {
                    closeBottomLayout();
                    return;
                }
                resetScroll();
                setOverlayShouldBeClosed(true);
            } else {
                if (ref.current && ref.current.scrollTop > scrollStep) {
                    setOverlayShouldBeClosed(false);
                }

                const isAtBottom = ref.current.scrollHeight - ref.current.scrollTop === ref.current.clientHeight;
                if (isAtBottom) {
                    props.onScrollEnd();
                }
            }
        }
    };

    const handleClickOutside = () => {
        if (animationInProgress === 0) {
            closeBottomLayout();
        }
    };

    return (
        <LayoutContainer>
            <Overlay $animationInProgress={animationInProgress} $openedBottomLayout={openedBottomLayout} onClick={handleClickOutside} />
            <div id="top-container">{props.topComponent}</div>
            <LayoutBottom
                ref={ref}
                onScroll={onScroll}
                className={`${classBottom}`}
                $animationInProgress={animationInProgress}
                $topPosition={topPosition}
                onTransitionEnd={() => {
                    setAnimationInProgress(0);
                    refStartAnimation.current = false;
                }}
            >
                <LayoutBottomInner>
                    <LayoutBottomHandler />
                    {props.children}
                </LayoutBottomInner>
            </LayoutBottom>
        </LayoutContainer>
    );
};

export { SeparateLayout };
